export var CalculatorNames;
(function (CalculatorNames) {
    CalculatorNames["WEDDINGPLANER"] = "Planer \u015Alubny";
})(CalculatorNames || (CalculatorNames = {}));
//# sourceMappingURL=names.js.map